module.exports = __webpack_public_path__ + "img/img31.160ea024.png";